/**
 * The query endpoints listed below are requested using the POST method
 * instead of the GET method.
 *
 * This is in place to get around an issue where some requests need to
 * send more data than fits in the URL.
 * This allows us to use the request body to send a bunch of data but
 * also gain the benefits of the Apollo cache.
 */ export default new Set([
    '/ajax/get_layout_v2',
    '/ajax/rank_dynamic_slots'
]);

//# sourceMappingURL=queriesToExecuteUsingPost.js.map